<template>
  <section id="sluzby" class="bg-white py-16 sm:py-24">
    <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div class="mx-auto max-w-3xl text-center">
        <span class="section-badge">Čo robíme</span>
        <h2 class="section-title mt-4">Naše služby</h2>
        <p class="section-subtitle">
          Vďaka dlhoročným skúsenostiam v rôznych technologických oblastiach vám
          vieme poskytnúť riešenie presne na mieru.
        </p>
      </div>

      <div
        class="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4"
      >
        <div
          v-for="skill in skills"
          :key="skill.title"
          class="card-surface group p-6"
        >
          <div
            class="mb-4 inline-flex h-11 w-11 items-center justify-center rounded-xl bg-brand-50 text-brand-600 ring-1 ring-brand-200 transition group-hover:bg-brand-600 group-hover:text-white group-hover:ring-brand-600"
          >
            <svg
              class="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                :d="skill.icon"
              />
            </svg>
          </div>
          <h3 class="text-base font-semibold text-gray-900">
            {{ skill.title }}
          </h3>
          <p class="mt-2 text-sm leading-6 text-gray-600">
            {{ skill.content }}
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
const iconPaths = {
  apps: "M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z",
  web: "M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9",
  hardware:
    "M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z",
  automation:
    "M13 10V3L4 14h7v7l9-11h-7z",
  docker:
    "M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10",
  systems:
    "M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z",
  database:
    "M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4",
  api: "M8 9l3 3-3 3m5 0h3M5 20h14a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z",
};

export default {
  setup() {
    return {
      skills: [
        {
          title: "Vývoj multiplatformových aplikácií",
          icon: iconPaths.apps,
          content:
            "Mobilné aplikácie pre Android a iOS, desktop pre macOS, Windows a Linux, progresívne webové aplikácie s Vue.js a React.",
        },
        {
          title: "Tvorba webových stránok",
          icon: iconPaths.web,
          content:
            "Web na mieru — návrh, implementácia a optimalizácia v moderných webových technológiách.",
        },
        {
          title: "Vývoj hardwarových riešení",
          icon: iconPaths.hardware,
          content:
            "Návrh hardvéru na mieru, plošné spoje, osadenie komponentov a integrácia do systému.",
        },
        {
          title: "Automatizácia procesov",
          icon: iconPaths.automation,
          content:
            "Mikrokontroléry so senzormi, integrácia do IS. LoRaWAN, WiFi a Bluetooth.",
        },
        {
          title: "Virtualizácia",
          icon: iconPaths.docker,
          content:
            "Docker/Podman, microservices architektúra a jednoduché nasadzovanie systémov.",
        },
        {
          title: "Vývoj informačných systémov",
          icon: iconPaths.systems,
          content:
            "Autentifikácia, autorizácia, zabezpečenie systémov a trojvrstvá architektúra.",
        },
        {
          title: "Databázové systémy",
          icon: iconPaths.database,
          content:
            "SQL (PostgreSQL, MariaDB, MSSQL) a NoSQL (MongoDB, Elastic, InfluxDB, Cassandra), ORM a optimalizácia dotazov.",
        },
        {
          title: "API",
          icon: iconPaths.api,
          content:
            "RESTful API, OpenAPI (Swagger), GraphQL a Apollo Server.",
        },
      ],
    };
  },
};
</script>
